import { render, staticRenderFns } from "./manageMoney.vue?vue&type=template&id=153c0a12&scoped=true&"
import script from "./manageMoney.vue?vue&type=script&lang=js&"
export * from "./manageMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c0a12",
  null
  
)

export default component.exports